import { render, staticRenderFns } from "./CallAll.vue?vue&type=template&id=584be773&scoped=true"
import script from "./CallAll.vue?vue&type=script&lang=js"
export * from "./CallAll.vue?vue&type=script&lang=js"
import style0 from "./CallAll.vue?vue&type=style&index=0&id=584be773&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584be773",
  null
  
)

export default component.exports